<template>
<!-- <div><br> -->
<!-- <div style="margin-top:20px; text-align:justify;" v-if="activo==0"> -->
  <div class="columns">
    <div class="column is-9" style="margin-left:10px;">
    <h2> Contacto </h2>

    <br><br>
    Correo electrónico: exodus@sistemy.mx
    <br><br>
    Chat directo: <a class="button is-info is-outlined is-small" href="https://www.messenger.com/t/691083214335683/?messaging_source=source%3Apages%3Amessage_shortlink&source_id=1441792" target="_blank" >Comenzar conversación</a>
    <br><br>
    Facebook oficial de Exodus: https://www.facebook.com/Exodus-M%C3%A9xico-691083214335683/
    <br><br>
    Sitio web oficial de Exodus: https://exodustickets.sistemy.mx/#/servicios
    

    </div>
  </div>
  
  

 

<!-- </div> -->


</template>

<script>

import axios from 'axios';
import qs from 'qs';
import Cors from 'cors';
import moment from 'moment';
import {SnotifyPosition, SnotifyStyle} from 'vue-snotify';
import searchMix from '../mixins/mixin.js'
import DatePick from 'vue-date-pick'
import VueClockPicker from '@pencilpix/vue2-clock-picker'
import { Carousel3d, Slide } from 'vue-carousel-3d';

export default {
  components:{
    DatePick,
    VueClockPicker,
    Carousel3d,
    Slide
  },
  data () {
    return {
      

    }
  },
  created(){
    console.log("terminos",this.$route.path)
    
  },
  computed:{
  },
  methods:{
  },
  mixins: [searchMix]
}
</script>
